import {DeterminantRow} from "./determinant-row";

export class FormulaRow extends DeterminantRow {
  public jsonLogic: any = "";
  public infix: any;
  public prettyPrintInfixFormula: any;
  public prettyPrintFinished: boolean = false;
}
